import { createFileRoute, redirect } from "@tanstack/react-router";

// Every catalog kind has a tab of its own; `/catalog` is the group, not a page.
// Procedures is the one it opens on.
export const Route = createFileRoute("/catalog/_layout/")({
  beforeLoad: () => {
    throw redirect({ to: "/catalog/procedures", replace: true });
  },
});
